export default __webpack_public_path__ + "static/media/ladySwapIcon.a66cb6f0.png";